import { render, staticRenderFns } from "./center.vue?vue&type=template&id=f2a94282"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2a94282')) {
      api.createRecord('f2a94282', component.options)
    } else {
      api.reload('f2a94282', component.options)
    }
    module.hot.accept("./center.vue?vue&type=template&id=f2a94282", function () {
      api.rerender('f2a94282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/center.vue"
export default component.exports